import { useTranslation } from 'next-i18next'

import { Dispatch, FC, SetStateAction } from 'react'

interface QuickOrderTabsProps {
  setActiveTab: Dispatch<SetStateAction<number>>
  activeTab: number
}

import ListsIcon from '@components/icons/quickorder/lists'
import QuickEntryIcon from '@components/icons/quickorder/quick-entry'
import ImportIcon from '@components/icons/quickorder/import'

const QuickOrderTabs: FC<QuickOrderTabsProps> = ({
  activeTab,
  setActiveTab,
}) => {
  const { t: translate } = useTranslation('quickorder')

  const tabs = [
    {
      title: 'text-lists',
      icon: <ListsIcon className="mb-2" />,
    },
    {
      title: 'text-quick-order',
      icon: <QuickEntryIcon className="mb-2" />,
    },
    {
      title: 'text-import',
      icon: <ImportIcon className="mb-2" />,
    },
  ]

  return (
    <div className="flex justify-center">
      <div className="flex justify-center mb-4 w-[80%] sm:w-[30%] ">
        {tabs.map((tab, index) => (
          <button
            className={`flex-1 py-1 sm:py-2  border  ${
              activeTab === index
                ? 'text-brand '
                : 'text-brand-gray grayscale opacity-50'
            } `}
            onClick={() => setActiveTab(index)}
          >
            <div className="flex flex-col items-center font-medium whitespace-nowrap uppercase text-[11px] ">
              {tab.icon}
              {translate(tab.title)}
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}

export default QuickOrderTabs
